import Icon from 'component/ui/Icon';
import { IconName, Intent } from 'enums';
import React from 'react';
import styled, { css } from 'styled-components';

export const DotLoading = styled.div`
  span {
    display: inline-block;
    margin-right: 10px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.black};
    animation: bump 0.6s infinite alternate;

    &:nth-child(1) {
      animation-delay: 0.2s;
    }

    &:nth-child(2) {
      animation-delay: 0.4s;
    }

    &:nth-child(3) {
      animation-delay: 0.6s;
      margin-right: 0;
    }
  }

  @keyframes bump {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.3);
    }
  }
`;

interface ISpiralLoading {
  $intent?: Intent;
  $rotate?: boolean;
}

export const SpiralLoadingThemed = styled(Icon)<ISpiralLoading>`
  width: 24px;
  height: 24px;
  ${(props) =>
    props.$intent === Intent.PRIMARY &&
    css`
      color: ${props.theme.intent.primary.foreground};
    `}

  ${(props) =>
    props.$intent === Intent.SECONDARY &&
    css`
      color: ${props.theme.intent.secondary.foreground};
    `}

  ${(props) =>
    props.$intent === Intent.TERTIARY &&
    css`
      color: ${props.theme.intent.tertiary.foreground};
    `}

    ${(props) =>
    props.$intent === Intent.QUATERNARY &&
    css`
      color: ${props.theme.intent.quaternary.foreground};
    `}

    ${(props) =>
    props.$intent === Intent.QUINARY &&
    css`
      color: ${props.theme.intent.quinary.foreground};
    `}



  ${(props) =>
    props.$intent === Intent.SUCCESS &&
    css`
      color: ${props.theme.intent.success.foreground};
    `}

  ${(props) =>
    props.$intent === Intent.WARNING &&
    css`
      color: ${props.theme.intent.warning.foreground};
    `}

  ${(props) =>
    props.$intent === Intent.DANGER &&
    css`
      color: ${props.theme.intent.danger.foreground};
    `}
`;

export const SpiralLoading = (props: ISpiralLoading) => (
  <SpiralLoadingThemed name={IconName.LOADER} {...props} rotate />
);
